import { render, staticRenderFns } from "./photoCellTest.vue?vue&type=template&id=45cd4dd0&scoped=true&"
import script from "./photoCellTest.vue?vue&type=script&lang=js&"
export * from "./photoCellTest.vue?vue&type=script&lang=js&"
import style0 from "./photoCellTest.vue?vue&type=style&index=0&id=45cd4dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cd4dd0",
  null
  
)

export default component.exports